import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

import { CustomerService } from 'app/00_modules/core/services/customer.service';
import { RouterService } from 'app/00_modules/core/services/router.service';
import { StorageService } from 'app/00_modules/core/services/storage.service';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, filter, take } from 'rxjs/operators';
import { NotificationService } from '../../core/services/notification.service';
import { UserService } from '../../core/services/user.service';
import { Customer } from './Customer';
import { UserFacade } from '../../../store/facade/user.facade';
import { CustomerFacade } from '../../../store/facade/customer.facade';
import { FormsModule } from '@angular/forms';
import { JeListComponent } from '../../shared/components/inputs/list/list.component';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'je-customerselection-container',
    standalone: true,
    templateUrl: './customer-selection.container.html',
    imports: [FormsModule, JeListComponent, TranslateModule, AsyncPipe],
})
export class CustomerSelectionContainerComponent implements OnInit {
    public customers$: Observable<Customer[]>;

    constructor(
        private customerService: CustomerService,
        private router: RouterService,
        private userService: UserService,
        private storageService: StorageService,
        protected notificationService: NotificationService,
        private userFacade: UserFacade,
        private customerFacade: CustomerFacade
    ) {}

    public onSelectionChanged(selectedCustomer: Customer) {
        if (selectedCustomer == null) {
            return;
        }

        this.customerFacade.setCurrentCustomer(selectedCustomer);
        this.storageService.setCustomerId(selectedCustomer.id);

        this.router.gotoHome();
    }

    public ngOnInit(): void {
        this.userFacade.currentRole$
            .pipe(
                // the customer can only be retrieved AFTER the current role has an actual value.
                // (The api service retrieves the role from the storage and sends along within the header.
                // Otherwise the server throws an error
                filter(role => !!role && !!role.name),
                take(1)
            )
            .subscribe(() => (this.customers$ = this.customerService.getCustomers().pipe(take(1), catchError(this.handleHttpError.bind(this)))));
    }

    private handleHttpError<T>(response: HttpErrorResponse): Observable<T> {
        if (response.status === HttpStatusCode.NotFound) {
            this.notificationService.errorTranslate('CUSTOMERSELECTION.CUSTOMER_NOTFOUND');
        } else {
            this.notificationService.errorTranslate('COMMON.ERROR.API_ERROR');
        }
        this.userService.logout();
        return observableThrowError(null);
    }
}
